import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import LocationPanel from './location/panel';
import { isFunction } from '../utils';

export default function TableLocation(Table) {
    return class LocationTable extends Component {
        constructor(props) {
            super(props);
            this.state = {
                openLocationModalFlag: false,
                selectedAttrcode: "",
                selectedColumn: "",
                currentIndex: props.currentIndex || -1,
                columnCurrentIndex: -1,
                currentSelectedColumn: {},
                locationIndexs: [],
                isTree: false,
            }
        }
        UNSAFE_componentWillReceiveProps(nextProps){
            let nextCurIndex = nextProps.currentIndex;
            let preCurIndex = this.state.currentIndex;
            if( typeof(nextCurIndex) === 'number' && nextCurIndex !== preCurIndex){
                this.setState({ currentIndex: nextProps.currentIndex });
            }
        }
        /**
         * 列信息扁平化处理
        * @param {原始列数据} columns 
        * @param {扁平列数据} flatColumns 
        */
        toFlatColumn(columns) {
            let flatColumns = []
            columns.forEach(item => {
                flatColumns.push(item);
                if (item.children) {
                    this.toFlatColumn(item.children, flatColumns);
                }
            });
            return flatColumns;
        }

        /**
         * 定位列增加标记
        * @param {原始列数据} columns 
        * @param {当前定位列} currentSelectedColumn 
        * @param {定位数组集合} locationIndexs 
        * @param {是否为树表} isTree 
        */
        toLocationColumn = (columns, currentSelectedColumn, locationIndexs, isTree) => {
            if (!currentSelectedColumn) {
                columns.forEach(item => {
                    item.className = item.className && item.className.replace(/column-location-td/g, "")
                    if (item.children) {
                        this.toLocationColumn(item.children, currentSelectedColumn, locationIndexs, isTree);
                    }
                });
                return columns;
            }
            columns.forEach(item => {
                if ((item.attrcode && item.attrcode === currentSelectedColumn.attrcode) || (item.dataIndex && item.dataIndex === currentSelectedColumn.dataIndex)) {
                    item.className = (item.className && item.className.includes("column-location-td ")) ? item.className : ("column-location-td " + item.className)
                } else {
                    item.className = item.className && item.className.replace(/column-location-td/g, "")
                }
                if (item.children) {
                    this.toLocationColumn(item.children, currentSelectedColumn, locationIndexs, isTree);
                }
            });
            return columns;
        }

        // 是否包含当前值
        isInclude = (arr, key, value) => {
            return arr.some(item => {
                return item[key] === value
            })
        }

        // 增加tr className
        getRowClassName = (record, index) => {
            const { isTree, locationIndexs, columnCurrentIndex } = this.state;
            let currentSelectedIndex = locationIndexs[columnCurrentIndex]?.value;
            let currentSelectedKey = locationIndexs[columnCurrentIndex]?.key;
            if (isTree) {
                if (currentSelectedKey === record.key) {
                    return "column-location-tr column-location-current-tr ";
                }
                return this.isInclude(locationIndexs, 'key', record.key) ? " column-location-tr " : "";
            } else {
                if (currentSelectedIndex === index) {
                    return "column-location-tr column-location-current-tr ";
                }
                return this.isInclude(locationIndexs, 'value', index) ? " column-location-tr " : "";
            }

        }

        // 定位icon点击事件
        onTitleLocationClick = item => {
            this.setState({
                openLocationModalFlag: true,
                // 兼容NCTable数据格式
                selectedAttrcode: item.attrcode || item.dataIndex,
                selectedColumn: item,
            })
        }
        // 渲染当前定位结果
        renderLocationResult = (locationIndexs, currentIndex, selectedColumn, selectedValue, treeTableRef, callback) => {
            let index = -1;
            if (currentIndex === -1) {
                index = -1;
            } else {
                index = locationIndexs[currentIndex].value;
            }
            this.preColumnCurrentIndex = this.state.columnCurrentIndex;
            this.setState({
                currentIndex: index,
                columnCurrentIndex: currentIndex,
                currentSelectedColumn: selectedColumn,
                selectedAttrcode: selectedValue,
                locationIndexs: locationIndexs,
                isTree: treeTableRef ? true : false,
            }, () => {
                isFunction(callback) && callback()
                // 设置currentIndex为-1
                this.renderCurrentIndex(-1)
            })
        }
        // 重置currentIndex
        renderCurrentIndex = (index, callback) => {
            this.setState({ currentIndex: index }, () => {
                // 激活第一个定位的单元格
                this.activeLocationCell()
                callback && callback()
            })
        }
        // 激活单元格
        activeLocationCell = () => {
            let { data, setLocationCell } = this.props;
            let { selectedAttrcode, columnCurrentIndex, locationIndexs } = this.state;
            let currentSelectedIndex = locationIndexs[columnCurrentIndex]?.value;
            currentSelectedIndex > -1 && setLocationCell && setLocationCell(data[currentSelectedIndex], selectedAttrcode, true);
            this.preColumnCurrentIndex > -1 && this.preColumnCurrentIndex !== currentSelectedIndex && setLocationCell && setLocationCell(data[this.preColumnCurrentIndex], selectedAttrcode, false);
        }

        render() {
            let { rowKey, customColData, data, columns=[], rowClassName, ...others } = this.props;
            let flatColumns = this.toFlatColumn(columns);
            let { selectedAttrcode, selectedColumn, currentIndex, openLocationModalFlag, currentSelectedColumn, locationIndexs, isTree } = this.state;
            let newColumns = this.toLocationColumn(columns, currentSelectedColumn, locationIndexs, isTree);

            return (
                <Fragment>
                    {openLocationModalFlag && <LocationPanel
                        tableColumns={flatColumns}
                        selectedAttrcode={selectedAttrcode}
                        selectedColumn={selectedColumn}
                        locationData={data}
                        rowKey={rowKey}
                        customColData={customColData}
                        onHide={() => {
                            this.setState({ openLocationModalFlag: false });
                        }}
                        tableDom={this.table}
                        tableScope={this}
                        renderLocationResult={this.renderLocationResult}
                        activeLocationCell={this.activeLocationCell}
                        renderCurrentIndex={this.renderCurrentIndex}
                    />}
                    <Table
                        {...others}
                        rowClassName={(record, index, indent) => {
                            let cls = this.getRowClassName(record, index, indent);
                            cls += isFunction(rowClassName) ? rowClassName(record, index) : rowClassName;
                            return cls;
                        }}
                        rowKey={rowKey}
                        columns={newColumns}
                        data={data}
                        customColData={customColData}
                        ref={dom => {
                            if (dom) {
                                this.table = ReactDOM.findDOMNode(dom);
                                if (this.props.treeTableRef) {
                                    this.props.treeTableRef.current = dom;
                                }
                            }
                        }}
                        locationCallback={this.onTitleLocationClick}
                        currentIndex={currentIndex}
                    />

                </Fragment>
            )
        }
    }
}

